export class Preferences {

  id: number | null = null;
  language = 'it';
  theme = 'A';
  tips = true;
  preferencesInitialized = false;

}
